import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as Styled from './TextButton.styled';

const TextButton = (props) => {
  const {
    classes,
    className,
    isDisabled,
    children,
    variant,
    ...passThroughProps
  } = props;

  return (
    <Styled.TextButtonComponent
      className={classnames(className, classes.root)}
      disabled={isDisabled}
      variant={variant}
      {...passThroughProps}>
      {children}
    </Styled.TextButtonComponent>
  );
};

TextButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['primary', 'slighter']),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

TextButton.defaultProps = {
  className: '',
  classes: {
    root: '',
  },
  isDisabled: false,
  children: null,

  variant: 'primary',
};

export default TextButton;
